// extracted by mini-css-extract-plugin
module.exports = {"title":"_315a8","wrapper":"a040d","agency":"_5775c","bio":"_8dd55","agency-title":"_8cfd9","agencyTitle":"_8cfd9","website":"fe19e","read-more":"d3161","readMore":"d3161"};